/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_Error_GenericInputs */

const fr_membership_friend_guest_error_generic = /** @type {(inputs: Membership_Friend_Guest_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'enregistrer l'invitation. Veuillez réessayer plus tard.`)
};

/**

* @param {Membership_Friend_Guest_Error_GenericInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_error_generic = /** @type {((inputs?: Membership_Friend_Guest_Error_GenericInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_Error_GenericInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_error_generic(inputs)
});